import React from 'react';
import { TrendingUp } from 'lucide-react';
import { FinanceiroGrafico } from './index';

const FluxoCaixaSection = ({ dadosFluxoCaixaHistoricoGrafico }) => {
  return (
    <div className="overflow-hidden">
      <div className="pt-6 sm:pt-3 pb-2">
        <div className="flex items-center justify-between mb-4 min-w-0">
          <h3 className="text-lg font-semibold text-[color:var(--text-primary)] flex items-center min-w-0 flex-1">
            <TrendingUp className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0" />
            <span className="truncate">Fluxo de Caixa Resumido</span>
          </h3>
        </div>
        <p className="text-sm text-[color:var(--text-muted)] mb-6">Evolução mensal de entradas e saídas</p>
        
        <div className="overflow-hidden">
          <FinanceiroGrafico
            tipo="line"
            dados={dadosFluxoCaixaHistoricoGrafico}
            altura="h-80"
          />
        </div>
      </div>
    </div>
  );
};

export default FluxoCaixaSection;


